import React from "react";
import {
  View,
  Text,
  StyleSheet,
  Image,
  TouchableOpacity,
  ImageSourcePropType,
  ImageBackground,
} from "react-native";
import {
  BuyBtn,
  buyNowChips,
  BuyVipBtn,
  VipBackgroundLandscape,
  VipBtnLights,
} from "../../../../assets";
import { Package } from "../../../../store/types";
import { useTranslation } from "react-i18next";

type VipCardProps = {
  vipIcon: ImageSourcePropType;
  textColor: string;
  vipLabel: ImageSourcePropType;
  borderColor: string;
  price: number;
  name: string;
  pkg: Package;
  onPayment: (packageItem: Package) => void;
};

const VipCard = ({
  vipIcon,
  textColor,
  vipLabel,
  borderColor,
  price,
  name,
  pkg,
  onPayment,
}: VipCardProps) => {
  const handleBuyPress = () => {
    onPayment(pkg);
  };
  const { t } = useTranslation();
  return (
    <View style={styles.cardWrapper}>
      <ImageBackground
        source={VipBackgroundLandscape}
        resizeMode="stretch"
        style={styles.background}
      >
        <View style={styles.card}>
          <View style={styles.right}>
            <View style={styles.labelRow}>
              <Image
                source={vipLabel}
                style={styles.vipLabel}
                resizeMode="contain"
              />
              <Text style={[styles.month, { color: textColor }]}>{name}</Text>
            </View>

            <View style={styles.left}>
              <Image
                source={vipIcon}
                style={styles.vipImage}
                resizeMode="contain"
              />
            </View>

            <Image source={VipBtnLights} style={styles.btnLight} />
            <Text style={styles.price}>{price}€</Text>
            <Image source={VipBtnLights} style={styles.btnLight} />

            <TouchableOpacity
              style={styles.buyNowButton}
              onPress={handleBuyPress}
            >
              <ImageBackground
                source={BuyVipBtn}
                style={styles.buyNowBtn}
                resizeMode="contain"
              >
                <View style={styles.centerContent}>
                  <Text style={styles.text}>{t("T_SITE_HEADER_BUY")}</Text>
                </View>
              </ImageBackground>
            </TouchableOpacity>
          </View>
        </View>
      </ImageBackground>
    </View>
  );
};

export default VipCard;

const styles = StyleSheet.create({
  cardWrapper: {
    // width: "28%",
    justifyContent: "center",
  },
  background: {
    width: "100%",
    maxWidth: 260,
  },
  card: {
    flexDirection: "row",
    alignItems: "center",
  },
  centerContent: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  labelRow: {
    flexDirection: "row",
    alignItems: "center",
    marginTop: 20,
  },
  left: {
    flex: 1,
    alignItems: "center",
  },
  right: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    paddingLeft: 12,
  },
  vipImage: {
    width: 200,
    height: 200,
  },
  vipLabel: {
    width: 46,
    height: 38,
  },
  text: {
    fontSize: 16,
    fontWeight: "700",
    letterSpacing: 0.8,
    color: "#E0E0E0",
    textShadowColor: "rgba(0, 0, 0, 0.9)",
    textShadowOffset: { width: 1, height: 1 },
    textShadowRadius: 12,
    textTransform: "uppercase",
    textAlign: "center",
    paddingTop: 5,
  },
  month: {
    fontSize: 28,
    fontWeight: "900",
    marginTop: 8,
  },
  price: {
    fontSize: 24,
    fontWeight: "500",
    color: "#fff",
    textAlign: "center",
    textShadowColor: "#000",
    textShadowOffset: { width: 1, height: 2 },
    textShadowRadius: 3,
    letterSpacing: 1,
    textTransform: "uppercase",
  },
  btnLight: {
    width: 50,
    height: 5,
  },
  buyNowButton: {
    borderRadius: 6,
    paddingBottom: 10,
  },
  buyNowBtn: {
    width: 150,
    height: 60,
    marginBottom: 20,
  },
});
